import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import HTMLReactParser from "html-react-parser"
import React from "react"

import RichText from "./richText/Parser"

export default function Hero({ component }) {
  const {
    richtitle,
    subtitle,
    backgroundImage,
    iphoneImage,
    button,
  } = component

  return (
    <div className="relative">
      {backgroundImage?.localFile?.childImageSharp?.gatsbyImageData && (
        <div className="w-full h-full absolute">
          <GatsbyImage
            className="absolute inset-0 w-full h-full object-cover"
            image={backgroundImage?.localFile?.childImageSharp?.gatsbyImageData}
            alt={backgroundImage?.altText}
          />
        </div>
      )}
      <div className=" relative">
        <div className="mx-auto max-w-7xl px-4 lg:px-8">
          <div className="sm:grid sm:grid-cols-3 md:gap-4 lg:grid-cols-2 lg:gap-8">
            <div className=" sm:col-span-2 lg:col-span-1 mx-auto max-w-xl text-center sm:max-w-4xl sm:text-left lg:flex lg:items-center">
              <div className="pt-20 pb-12 sm:pt-24 sm:pb-16 md:text-left lg:pt-48 lg:pb-28">
                {richtitle && (
                  <RichText stringHtml={richtitle} option="heroTitle" />
                )}
                {subtitle && (
                  <p className="mt-4 text-xl tracking-tight text-charlestonGreen-500 sm:mt-5 sm:text-xl lg:mt-6 xl:text-xl">
                    {HTMLReactParser(subtitle)}
                  </p>
                )}
                <div className="mt-8 flex gap-8 items-center justify-center sm:justify-start">
                  {button?.url && button?.title && (
                    <Link
                      className="inline-flex btn px-4 py-2 shadow-sm "
                      to={button.url}
                      target={button?.target}
                    >
                      {button?.title}
                    </Link>
                  )}
                </div>
              </div>
            </div>
            <div className="pb-8 sm:pb-0 flex w-full h-full justify-center items-end sm:justify-end">
              <GatsbyImage
                className="sm:-mb-10 w-full object-contain"
                image={iphoneImage?.localFile?.childImageSharp?.gatsbyImageData}
                alt={iphoneImage?.altText}
                objectFit="contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
